<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<adicionar-items-lista-adicionales #appvaloresposiblesmodal (ConfirmoUsuario)="SeleccionoValoresPosibles($event)"></adicionar-items-lista-adicionales>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>

<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoCargaRecurrenciaArchivos()" *ngIf="idTabSeleccionado === 1 && !editarRegistroCargaRecurrenteArchivos" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="idTabSeleccionado === 1 && editarRegistroCargaRecurrenteArchivos">
            <a type="button" class="icnTable" (click)="GuardarCargaRecurrenciaArchivos()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarCargaRecurrenciaArchivos()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ruta (*)</mat-label>
                        <input matInput formControlName="ruta" autocomplete="off">
                        <mat-error *ngIf="form.get('ruta').hasError('required')">La Ruta es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('ruta').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Descripción (*)</mat-label>
                        <input matInput formControlName="descripcion" autocomplete="off">
                        <mat-error *ngIf="form.get('descripcion').hasError('required')">La Descripción es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('descripcion').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Permitir subir archivos (*)</mat-label>
                        <mat-select formControlName="subirArchivo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Permitir eliminar (*)</mat-label>
                        <mat-select formControlName="eliminar">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ver Subdirectorios (*)</mat-label>
                        <mat-select formControlName="subdirectorios">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="form.get('id').value > 0">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Activo (*)</mat-label>
                        <mat-select formControlName="activo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Roles</mat-label>
                        <mat-select formControlName="rolesSeleccionados" multiple>
                            <mat-option [value]="item.idRol" *ngFor="let item of this.listaDatosRoles">{{item.nombreRol}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Usuarios</mat-label>
                        <mat-select formControlName="usuariosSeleccionados" multiple>
                            <mat-option [value]="item.idUsuario" *ngFor="let item of this.listaDatosUsuarios">{{item.login}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Filtro archivos</mat-label>
                        <input matInput formControlName="filtroArchivos" autocomplete="off">
                        <mat-error *ngIf="form.get('filtroArchivos').hasError('required')">El Filtro archivos es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('filtroArchivos').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Carga recurrente archivos</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formCargaRecurrenteArchivos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroCargaRecurrenteArchivos">
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Carga activa (*)</mat-label>
                            <mat-select formControlName="cargaActiva" [disabled]="this.formCargaRecurrenteArchivos.get('id').value === 0">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Aliado (*)</mat-label>
                            <mat-select formControlName="aplicacion">
                                <mat-option [value]="item.idAplicacion" *ngFor="let item of this.listaDatosAplicaciones">{{item.nombre}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tomar ruta principal (*)</mat-label>
                            <mat-select formControlName="tomarRutaPrincipal">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ruta carga archivos (*)</mat-label>
                            <input matInput formControlName="rutaCargaArchivos" autocomplete="off" [readonly]="this.formCargaRecurrenteArchivos.get('tomarRutaPrincipal').value">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaCargaArchivos').hasError('required')">La Ruta carga archivos es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaCargaArchivos').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Extensión archivo lectura (*)</mat-label>
                            <mat-select formControlName="extensionLectura">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaExtensiones">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('extensionLectura').hasError('required')">La Extensión archivo lectura es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('extensionLectura').hasError('maxlength')">La longitud máxima es 10</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12" *ngIf="this.EsPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Extensiones archivo plano (*)</mat-label>
                            <input matInput formControlName="extensionesFiltro" autocomplete="off" [readonly]="true">
                            <button matSuffix mat-icon-button (click)="EditarParametroValoresPosiblesExtensionesFiltro()">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('extensionesFiltro').hasError('required')">Las Extensiones archivo plano es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('extensionesFiltro').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Separador columnas plano (*)</mat-label>
                            <input matInput formControlName="separadorColumnas" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('separadorColumnas').hasError('required')">El Separador columnas plano procesado es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('separadorColumnas').hasError('maxlength')">La longitud máxima es 10</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ruta mover archivo procesado (*)</mat-label>
                            <input matInput formControlName="rutaBackupCargaArchivos" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaBackupCargaArchivos').hasError('required')">La Ruta mover archivo procesado es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaBackupCargaArchivos').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-4 col-12" *ngIf="!this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Procedimiento carga archivos (*)</mat-label>
                            <input matInput formControlName="procedimientoCargaEnOrigen" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').hasError('required')">La Procedimiento carga archivos es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('procedimientoCargaEnOrigen').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12" *ngIf="!this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ruta mover bulkinsert</mat-label>
                            <input matInput formControlName="rutaMoverArchivos" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaMoverArchivos').hasError('required')">La Ruta mover bulkinsert es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaMoverArchivos').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12" *ngIf="!this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ruta interna bulkinsert (SQL)</mat-label>
                            <input matInput formControlName="rutaBulkInsert" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaBulkInsert').hasError('required')">La Ruta interna bulkinsert (SQL) es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaBulkInsert').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12" *ngIf="!this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ruta formato bulkinsert</mat-label>
                            <input matInput formControlName="rutaFormato" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaFormato').hasError('required')">La Ruta formato bulkinsert es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaFormato').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Cliente carga (*)</mat-label>
                            <input matInput formControlName="clienteCarga" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('clienteCarga').hasError('required')">El cliente de la carga es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('clienteCarga').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Canal o exponsor (*)</mat-label>
                            <input matInput formControlName="archivoCarga" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('archivoCarga').hasError('required')">El archivo de la carga es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('archivoCarga').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Producto (*)</mat-label>
                            <input matInput formControlName="archivoProducto" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('archivoProducto').hasError('required')">El producto de la carga es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('archivoProducto').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Nro Identificación (*)</mat-label>
                            <input matInput formControlName="columnaIdentificacion" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaIdentificacion').hasError('required')">La Columna Nro Identificación es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaIdentificacion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Nombre (*)</mat-label>
                            <input matInput formControlName="columnaNombre" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaNombre').hasError('required')">La Columna Nombre es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaNombre').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Apellido</mat-label>
                            <input matInput formControlName="columnaApellido" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaApellido').hasError('required')">La Columna Nombre es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaApellido').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Registro único</mat-label>
                            <input matInput formControlName="columnaRegistroUnico" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaRegistroUnico').hasError('required')">La Columna Registro único es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaRegistroUnico').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Fecha inicial (*)</mat-label>
                            <input matInput formControlName="columnaFechaInicial" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaFechaInicial').hasError('required')">La Columna Fecha inicial es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaFechaInicial').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Fecha final (*)</mat-label>
                            <input matInput formControlName="columnaFechaFinal" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaFechaFinal').hasError('required')">La Columna Fecha final es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaFechaFinal').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Email</mat-label>
                            <input matInput formControlName="columnaEmail" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaEmail').hasError('required')">La Columna Email es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaEmail').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columna Nro movil</mat-label>
                            <input matInput formControlName="columnaNroMovil" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaNroMovil').hasError('required')">La Columna Nro movil es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnaNroMovil').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columnas adicionales visualizar</mat-label>
                            <input matInput formControlName="columnasVisualizar" autocomplete="off" [readonly]="true">
                            <button matSuffix mat-icon-button (click)="EditarParametroValoresPosiblesAdicionalesVisualizar()">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnasVisualizar').hasError('required')">Las Columnas adicionales visualizar es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnasVisualizar').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mostrar beneficiarios</mat-label>
                            <mat-select formControlName="mostrarBeneficiarios">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.EsExcelPlano() && this.formCargaRecurrenteArchivos.get('mostrarBeneficiarios').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Columnas beneficiarios (*)</mat-label>
                            <input matInput formControlName="columnasBeneficiarios" autocomplete="off" [readonly]="true">
                            <button matSuffix mat-icon-button (click)="EditarParametroValoresPosiblesColumnasBeneficiarios()">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnasBeneficiarios').hasError('required')">Las Columnas beneficiarios es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('columnasBeneficiarios').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Terminos y condiciones</mat-label>
                            <input matInput formControlName="rutaTerminosCondiciones" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaTerminosCondiciones').hasError('required')">La Columna Terminos y condiciones es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaTerminosCondiciones').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Control de operaciones</mat-label>
                            <input matInput formControlName="rutaControlOperaciones" autocomplete="off">
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaControlOperaciones').hasError('required')">La Columna Control de operaciones es un campo requerido</mat-error>
                            <mat-error *ngIf="formCargaRecurrenteArchivos.get('rutaControlOperaciones').hasError('maxlength')">La longitud máxima es 500</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12" *ngIf="this.MostrarMigrarDatosDestino()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Aplicación destino</mat-label>
                            <mat-select formControlName="idAplicacionDestino">
                                <mat-option [value]="item.idAplicacion" *ngFor="let item of this.listaDatosAplicacionesDestino">{{item.nombre}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Canal</mat-label>
                            <mat-select formControlName="idCanal">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaCanales">{{item.nombre}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Producto</mat-label>
                            <mat-select formControlName="idProducto">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaProductos">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ocultar estadisticas</mat-label>
                            <mat-select formControlName="ocultarEstadisticas">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceCargaRecurrenteArchivos" matSort class="table table-striped table-hover">

                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <!-- tomarRutaPrincipal Column -->
                            <ng-container matColumnDef="tomarRutaPrincipal">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tomar ruta principal </th>
                                <td mat-cell *matCellDef="let row"> {{row.tomarRutaPrincipal ? 'Si' : 'No'}} </td>
                            </ng-container>
                            <!-- rutaCargaArchivos Column -->
                            <ng-container matColumnDef="rutaCargaArchivos">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ruta carga archivos </th>
                                <td mat-cell *matCellDef="let row"> {{row.rutaCargaArchivos}} </td>
                            </ng-container>
                            <!-- extensionLectura Column -->
                            <ng-container matColumnDef="extensionLectura">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Extensión archivos </th>
                                <td mat-cell *matCellDef="let row"> {{row.extensionLectura}} </td>
                            </ng-container>
                            <!-- cargaActiva Column -->
                            <ng-container matColumnDef="cargaActiva">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Carga activa </th>
                                <td mat-cell *matCellDef="let row"> {{row.cargaActiva ? 'Si' : 'No'}} </td>
                            </ng-container>
                            <!-- acciones Column -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarCargaRecurrenciaArchivos(row)" *ngIf="!editarRegistroCargaRecurrenteArchivos">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarCargaRecurrenciaArchivos(row)" *ngIf="!editarRegistroCargaRecurrenteArchivos">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="MigrarDatos(row)" *ngIf="!editarRegistroCargaRecurrenteArchivos && MostrarMigrarDatosDestinoRegistro(row)">
                                        <mat-icon>cached</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoCargaRecurrenteArchivos"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoCargaRecurrenteArchivos;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0" *ngIf="idTabSeleccionado === 0 || (idTabSeleccionado === 1 && !editarRegistroCargaRecurrenteArchivos)">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>